
import { Link } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

export default function FeaturedPosts() {
  const featuredPosts = blogPosts.filter(post => post.featured).slice(0, 3);
  const mainPost = featuredPosts[0];
  const sidePosts = featuredPosts.slice(1, 3);

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-black to-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className="flex items-center gap-2 bg-accent-green/15 px-4 py-2 rounded-full">
            <i className="ri-star-fill text-accent-green"></i>
            <span className="text-accent-green text-sm font-medium">Em Destaque</span>
          </div>
        </div>

        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-10">
          Artigos Mais Lidos
        </h2>

        {/* Featured Grid */}
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Main Featured Post */}
          <Link
            to={`/blog/${mainPost.slug}`}
            className="group relative h-[400px] sm:h-[500px] rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src={mainPost.image}
              alt={mainPost.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            
            <div className="absolute top-4 left-4">
              <span className={`${mainPost.categoryColor} text-black px-3 py-1 rounded-full text-xs font-bold`}>
                {mainPost.category}
              </span>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 group-hover:text-accent-green transition-colors">
                {mainPost.title}
              </h3>
              <p className="text-gray-300 text-sm sm:text-base mb-4 line-clamp-2">
                {mainPost.excerpt}
              </p>
              <div className="flex items-center gap-4">
                <img
                  src={mainPost.authorAvatar}
                  alt={mainPost.author}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="flex items-center gap-3 text-sm text-gray-400">
                  <span className="text-white font-medium">{mainPost.author}</span>
                  <span>•</span>
                  <span>{mainPost.date}</span>
                  <span>•</span>
                  <span>{mainPost.readTime} de leitura</span>
                </div>
              </div>
            </div>
          </Link>

          {/* Side Posts */}
          <div className="flex flex-col gap-6">
            {sidePosts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-dark-secondary rounded-2xl overflow-hidden flex flex-col sm:flex-row cursor-pointer hover:bg-dark-secondary/80 transition-colors"
              >
                <div className="sm:w-2/5 h-48 sm:h-auto relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`${post.categoryColor} text-black px-3 py-1 rounded-full text-xs font-bold`}>
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="sm:w-3/5 p-5 sm:p-6 flex flex-col justify-center">
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-3 group-hover:text-accent-green transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-gray-500">
                    <img
                      src={post.authorAvatar}
                      alt={post.author}
                      className="w-7 h-7 rounded-full object-cover"
                    />
                    <span className="text-gray-300">{post.author}</span>
                    <span>•</span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
